import { CHAT_MSG_TYPE } from "../define";
import request, { createRequest } from "./request";
import UA from 'ua-device'
class utils {

    static getUrlParams (url) {
    
        let result = {};
        const arr_= url.split('?')
        if(arr_.length<=1){
            return result
        }
        const paramArr = arr_[1].split('&')
        for(let i=0;i<paramArr.length;++i){
            const _arr = paramArr[i].split('=')
            if(_arr.length==2){
                result[_arr[0]]=_arr[1]
            }
        }
        return result
    }

    static getModelNameRemoveVersion(name){
        if(!name){
            return;
        }
        let index = name.lastIndexOf("_V")
        if(index<0){//尝试区分下大小写
            index = name.lastIndexOf("_v")
        }
        if(index<0){//使用源字符串
            return name
        }
        let nameNew =name.substring(0,index)
        nameNew=nameNew.toLowerCase()
        return nameNew
    }
     
    static postData(url,api, data){
        return new Promise((resolve,reject)=>{
            createRequest(url).request({
                url: api,
                method: 'post',
                headers: {
                    // 'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data
            }).then(dat=>{
                console.log('----',dat)
                if(dat.status!=200){
                    reject(dat.status,'请求失败')
                }
                else{
                    resolve(dat.data)
                }
            },err=>{
                reject(501,'请求失败')
            })
        })
        
    }
    static getNavicatObj () {
       
        var output = new UA(navigator.userAgent);
        return output
    }
    static parseRobotMessage(message){
        var [isImg,url] = this.parseRobotImgMessage(message)
        if(isImg){
            return [CHAT_MSG_TYPE.IMG,url]
        }
        return [CHAT_MSG_TYPE.WORD,message]
    }
    static parseRobotImgMessage(message){
        const regex = /https?:\/\/[^\s]+/g;
        const matches = message.replace(/^!\[\]\((.*)\)$/, '$1');
        const url = matches.split("?")[0]
        let lastExt =url.substring(url.lastIndexOf('.')+1) 
        console.log('url',lastExt)
        const IMG_EXT=['png','jpg','jpeg','gif','svg','bmp','ico']
        if(IMG_EXT.indexOf(lastExt.toLowerCase())>=0){
            return [true,matches]
        }
        else{
            return [false,message]
        }
    }

    static  dataURLToBlob(dataurl) {
        const type = dataurl.match(/data:(.+);/)[1];
        const base64 = dataurl.split(',')[1];
        const binStr = atob(base64);
        const u8a = new Uint8Array(binStr.length);
        let p = binStr.length;
        while (p) {
          p--;
          u8a[p] = binStr.codePointAt(p);
        }
        return new Blob([u8a], { type });
    }
    static dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }
   
   
}

export {utils}



// WEBPACK FOOTER //
// ./src/S51WebGLSDK/utils/utils.js